// KWANKGM02010_借入相談入力
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import {
  ParentShelf,
  ChildShelf,
  Content,
  GuarantorInfo,
  StepNavigation as StepType,
} from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import MypageReturn from '../../molecules/MypageReturn';
import AgreementInfo from '../../templates/AgreementInfo';
import { KeyValue } from '../../types/KeyValue';
import { status_code_list } from '../../Const';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  is_staff: boolean;
  guarantors_num: number;
  is_loading: boolean;
  display_status: boolean;
  show_error_nav: boolean;
  callApi: (function_name: string) => Promise<any>;
  guarantor_info: GuarantorInfo;
  agreement_info: KeyValue[];
  status: number;
}

const BorrowingConsultationReferencePreview: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  is_staff,
  guarantors_num,
  is_loading,
  display_status,
  show_error_nav,
  callApi,
  guarantor_info,
  agreement_info,
  status,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      {/* 連帯債務者等が0人、案件ステータスが91550の場合は非表示、1人以上の場合は表示する */}
      {guarantors_num !== 0 && status !== status_code_list.borrowing_consultation_result_ng && (
        <AgreementInfo agreement_info={agreement_info} />
      )}
      <MypageReturn is_staff={is_staff} />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default BorrowingConsultationReferencePreview;
